import { render, staticRenderFns } from "./TopTenCardView.vue?vue&type=template&id=4c7ee873&scoped=true&"
import script from "./TopTenCardView.vue?vue&type=script&lang=js&"
export * from "./TopTenCardView.vue?vue&type=script&lang=js&"
import style0 from "./TopTenCardView.vue?vue&type=style&index=0&id=4c7ee873&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ee873",
  null
  
)

export default component.exports